import React, { useCallback, useState, useEffect } from 'react'
import useStyles from './styles'
import WidgetTitle from 'components/common/WidgetTitle/WidgetTitle'
import { useDispatch, useSelector } from 'react-redux'
import { sendTributeToArtist } from 'redux/slices/liveShow/thunks'
import { getTributeValues } from 'redux/slices/liveShow'
import { Alert } from '@material-ui/lab'

const TributeWidget: React.FC = () => {
    const classes = useStyles()
    const inputName = 'tributeInput'
    const tribute = useSelector(getTributeValues)
    const [showAlert, setShowAlert] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (tribute.result) {
            setShowAlert(true)
        }
    }, [tribute.result])

    const onAlertClose = useCallback(() => {
        setShowAlert(false)
    }, [])

    const onSubmit = useCallback(
        (event: React.SyntheticEvent) => {
            event.preventDefault()
            const target = event.target as HTMLFormElement
            const note = target.elements[inputName].value
            if (!tribute.sending) {
                dispatch(sendTributeToArtist({ note }))
            }
        },
        [dispatch, tribute],
    )

    return (
        <section>
            <WidgetTitle heading="Message The Host" subHeading="Your message will be sent directly to the host." />
            <form className={classes.form} onSubmit={onSubmit}>
                {showAlert && !tribute.sending && (
                    <Alert severity={tribute.result!} className={classes.alert} onClose={onAlertClose}>
                        {tribute.message}
                    </Alert>
                )}
                <div className={classes.inputWrapper}>
                    <textarea
                        className={classes.textarea}
                        placeholder="Enter your message here."
                        name={inputName}
                        required
                    ></textarea>
                    <button type="submit" className={classes.btn} disabled={tribute.sending} />
                </div>
            </form>
        </section>
    )
}

export default React.memo(TributeWidget)
